"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var data = {};
var storage = {
  get: function get(key, defaultValue) {
    var _a, _b;

    try {
      return (_a = data[key]) !== null && _a !== void 0 ? _a : JSON.parse((_b = localStorage.getItem(key)) !== null && _b !== void 0 ? _b : '');
    } catch (_c) {
      return defaultValue;
    }
  },
  set: function set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      data[key] = undefined;
      return true;
    } catch (_a) {
      data[key] = value;
      return false;
    }
  }
};
var initializedStorageKeys = new Set();

function useLocalStorageState(key, defaultValue) {
  var _react_1$useState = react_1.useState(function () {
    var isCallable = function isCallable(value) {
      return typeof value === 'function';
    };

    return {
      isPersistent: function () {
        if (typeof window === 'undefined') {
          return true;
        }

        try {
          localStorage.setItem('--use-local-storage-state--', 'dummy');
          localStorage.removeItem('--use-local-storage-state--');
          return true;
        } catch (_a) {
          return false;
        }
      }(),
      value: isCallable(defaultValue) ? storage.get(key, defaultValue()) : storage.get(key, defaultValue)
    };
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var updateValue = react_1.useCallback(function (newValue) {
    setState(function (state) {
      var isCallable = function isCallable(value) {
        return typeof value === 'function';
      };

      var value = isCallable(newValue) ? newValue(state.value) : newValue;
      return {
        value: value,
        isPersistent: storage.set(key, value)
      };
    });
  }, [key]);
  react_1.useEffect(function () {
    if (initializedStorageKeys.has(key)) {
      throw new Error("Multiple instances of useLocalStorageState() has been initialized with the same key. " + "Use createLocalStorageStateHook() instead. " + "Example implementation: " + "https://github.com/astoilkov/use-local-storage-state#create-local-storage-state-hook-example");
    } else {
      initializedStorageKeys.add(key);
    }

    return function () {
      return void initializedStorageKeys.delete(key);
    };
  }, []);
  react_1.useEffect(function () {
    var onStorage = function onStorage(e) {
      if (e.storageArea === localStorage && e.key === key) {
        setState({
          isPersistent: true,
          value: e.newValue === null ? defaultValue : JSON.parse(e.newValue)
        });
      }
    };

    window.addEventListener('storage', onStorage);
    return function () {
      return window.removeEventListener('storage', onStorage);
    };
  }, []);
  return [state.value, updateValue, state.isPersistent];
}

exports.default = useLocalStorageState;

function createLocalStorageStateHook(key, defaultValue) {
  var updates = [];
  return function useLocalStorageStateHook() {
    var _useLocalStorageState = useLocalStorageState(key, defaultValue),
        _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 3),
        value = _useLocalStorageState2[0],
        setValue = _useLocalStorageState2[1],
        isPersistent = _useLocalStorageState2[2];

    var updateValue = react_1.useCallback(function (newValue) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var update = _step.value;
          update(newValue);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }, []);
    react_1.useEffect(function () {
      initializedStorageKeys.delete(key);
    }, []);
    react_1.useEffect(function () {
      updates.push(setValue);
      return function () {
        return void updates.splice(updates.indexOf(setValue), 1);
      };
    }, [setValue]);
    return [value, updateValue, isPersistent];
  };
}

exports.createLocalStorageStateHook = createLocalStorageStateHook;